import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BreadCrumbs from '../../components/BreadСrumbs/BreadСrumbs';
import { ProfileAvatar } from '../../components/User/ProfileAvatar';
import { UserStatistic } from '../../components/User/UserStatistic';
import { PersonalInfoItem } from '../../components/Inputs/PersonalInfoItem';
import { GetProfile } from '../../utils/api/services/profile';
import Preloader from '../../components/Preloader/Preloader';
import paths from '../../paths';

const inputs = [
  {
    name: 'firstName',
    placeholder: 'Имя',
  },
  {
    name: 'lastName',
    placeholder: 'Фамилия',
  },
  {
    name: 'phone',
    type: 'tel',
    placeholder: 'Телефон',
  },
  {
    name: 'email',
    type: 'email',
    placeholder: 'Email',
  },
  {
    name: 'position',
    placeholder: 'Должность',
  },
  {
    name: 'company',
    placeholder: 'Компания',
  },
  {
    name: 'city',
    placeholder: 'Город',
  },
  // {
  //   name: 'opticalNetwork',
  //   placeholder: 'Оптическая сеть',
  // }
];

export class Profile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      user: null,
      statistic: null,
    };
  }

  componentWillMount = () => {
    GetProfile(this.props.match.params.profileId).then(result => {
      this.setState({
        isLoading: false,
        user: result.user,
        statistic: { ...result.statistic, visitsCount: result.user.visitsCount }
      });
    }).catch(e => console.log(e));
  };

  render() {
    const { user, statistic, isLoading } = this.state;

    if (isLoading) {
      return <Preloader />;
    }
    
    const fullName = `${user.firstName} ${user.lastName}`;
    return (
      <div className="b-center bg-dragonfly5">
        <BreadCrumbs
          data={[{ url: paths.advocates.main, text: 'Главная' }, { url: this.props.match, text: fullName }]}
        />
        <h1 className="title">{fullName}</h1>
        <div className="page-container">
          <div className="user-profile clearfix">
            <ProfileAvatar
              canEdit={false}
              user={user}
            />
            <div className="user-profile__block user-profile__personal-info">
              <h2 className="page-subtitle">Личная информация:</h2>
              {inputs.filter(x => user[x.name]).map(item => (
                <PersonalInfoItem
                  key={item.name}
                  placeholder={item.placeholder}
                  value={user[item.name]}
                />
              ))}
            </div>

            <UserStatistic statistic={statistic} />
          </div>
        </div>
      </div>
    );
  }

  static propTypes = {
    user: PropTypes.object.isRequired,
  };
}
